import React from 'react';
import { TabsItem } from 'components/Tabs';
import Flex, { Grid } from 'components/Flex';
import { FaUserShield } from 'react-icons/fa';
import ICivilPolice from 'interfaces/civilPolice';
import { WrapperName, LineTitle } from './styles';

interface PoliceCivilData {

  detailPolice: ICivilPolice[];

}

const PcDetail: React.FC<PoliceCivilData> = ({ detailPolice }) => {
  const PoliceCivil = detailPolice;

  return (
    <TabsItem title="Autoridade Policial">
      <Grid container justify="flex-start" spacing={1}>
        {PoliceCivil?.map((pCivil:any) => (
          <Grid item key={pCivil.id} xs={12} sm={12} md={12}>
            <LineTitle>
              <Grid container spacing={1}>
                <WrapperName>
                  <FaUserShield />&nbsp;{pCivil.name}
                </WrapperName>
                <Flex title="Delagacia" xs={12} sm={6} md={6}>
                  {pCivil.initials}
                </Flex>
                <Flex title="Local" xs={12} sm={6} md={6}>
                  {pCivil.local}
                </Flex>
                <Flex title="Matrícula" xs={12} sm={6} md={6}>
                  {pCivil.document}
                </Flex>
                <Flex title="Função" xs={12} sm={6} md={6}>
                  {pCivil.office_dp}
                </Flex>
              </Grid>
            </LineTitle>
          </Grid>
        ))}
      </Grid>
    </TabsItem>
  );
};

export default PcDetail;
